import Box from '@quintoandar/cozy-core/Box';
import Typography from '@quintoandar/cozy-core/Typography';
import Download from '@quintoandar/cozy-icons/Download';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { ChooseFile } from './ChooseFile/ChooseFile';
import messages from './messages';

export const DragAndDropFile = ({
  isFileInputEnabled,
  onFileDrop,
  title,
  subtitle,
  inputType,
}) => {
  const intl = useIntl();
  const [isDraggingOver, setIsDraggingOver] = useState(false);

  const handleFileDragEnter = (e) => {
    e.preventDefault();
    setIsDraggingOver(true);
  };

  const handleFileDragLeave = (e) => {
    e.preventDefault();
    setIsDraggingOver(false);
  };
  const handleFileDrop = (e) => {
    e.preventDefault();
    setIsDraggingOver(false);
    onFileDrop(e.dataTransfer.files);
  };

  return (
    <div
      style={{
        width: '100%',
        height: '300px',
        border:
          isDraggingOver && isFileInputEnabled
            ? '2px dashed #153f63'
            : '2px dashed #9c9c9c',
        borderRadius: '5px',
        backgroundColor:
          isDraggingOver && isFileInputEnabled ? '#d7eafa' : '#f2f2f2',
      }}
      onDragOver={handleFileDragEnter}
      onDragLeave={handleFileDragLeave}
      onDrop={handleFileDrop}
    >
      <Box
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Box maxWidth="450px">
          <Box display="flex" justifyContent="center" mb={2}>
            <Download
              fontSize="large"
              color={isFileInputEnabled ? 'inherit' : 'disabled'}
            />
          </Box>
          <Box mb={1}>
            <Typography
              align="center"
              level="title"
              kind={isFileInputEnabled ? 'default' : 'disabled'}
            >
              {title}
            </Typography>
          </Box>
          <Typography
            align="center"
            kind={isFileInputEnabled ? 'lighter' : 'disabled'}
            level="bodyStrong"
          >
            {subtitle}
          </Typography>
          <ChooseFile
            enabled={isFileInputEnabled}
            buttonName={intl.formatMessage(messages.chooseOneFile)}
            handleSelectedFiles={(files) => onFileDrop(files)}
            inputType={inputType}
          />
        </Box>
      </Box>
    </div>
  );
};

DragAndDropFile.propTypes = {
  isFileInputEnabled: PropTypes.bool.isRequired,
  onFileDrop: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  inputType: PropTypes.string.isRequired,
};
